/* emberdose-candle.js — shared behavior for the Emberdose "Sweet Melt Massage Candle" PDP.
   Scoped to [data-ec-*] hooks only; never touches other theme markup. */
(function () {
  if (window.__ecCandleInit) return;
  window.__ecCandleInit = true;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    // ---- Quantity steppers (one per form: hero + final CTA can each have their own) ----
    // Replicates Shopify's `money` filter client-side, handling every money-format
    // token Shopify supports (not just the bare {{amount}} token). The naive version
    // this replaced only matched {{amount}} and silently left any other token (e.g.
    // {{amount_with_comma_separator}}, used by several Markets locales such as
    // Uruguay) untouched, so the raw "${{amount_with_comma_separator}}" template
    // text leaked onto the Add to Cart button instead of a real price.
    function ecFormatMoney(cents, format) {
      format = format || '${{amount}}';
      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, token) {
        var thousandsSeparator = ',';
        var decimalSeparator = '.';
        var precision = 2;

        switch (token) {
          case 'amount':
            break;
          case 'amount_no_decimals':
            precision = 0;
            break;
          case 'amount_with_comma_separator':
            thousandsSeparator = '.';
            decimalSeparator = ',';
            break;
          case 'amount_no_decimals_with_comma_separator':
            thousandsSeparator = '.';
            precision = 0;
            break;
          case 'amount_no_decimals_with_space_separator':
            thousandsSeparator = ' ';
            precision = 0;
            break;
          case 'amount_with_space_separator':
            thousandsSeparator = ' ';
            decimalSeparator = ',';
            break;
          case 'amount_with_period_and_space_separator':
            thousandsSeparator = ' ';
            decimalSeparator = '.';
            break;
          case 'amount_with_apostrophe_separator':
            thousandsSeparator = "'";
            decimalSeparator = '.';
            break;
          default:
            // Unknown/unsupported token (e.g. "currency") — drop it rather than
            // leaking the raw {{ token }} text onto the button.
            return '';
        }

        var rounded = (cents / 100).toFixed(precision);
        var parts = rounded.split('.');
        var whole = (parts[0] || '0').replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
        var fraction = parts[1] || '';
        return precision <= 0 ? whole : whole + decimalSeparator + fraction;
      });
    }

    document.querySelectorAll('[data-ec-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-ec-qty-input]');
      var display = wrap.querySelector('[data-ec-qty-value]');
      if (!input) return;
      var updateSubmitPrice = function (qty) {
        var form = wrap.closest('form');
        var btn = form && form.querySelector('[data-ec-submit]');
        if (!btn || !btn.hasAttribute('data-unit-price-cents')) return;
        var unitPriceCents = parseInt(btn.getAttribute('data-unit-price-cents'), 10);
        if (isNaN(unitPriceCents)) return;
        var label = btn.getAttribute('data-cta-label') || '';
        var moneyFormat = btn.getAttribute('data-money-format') || '${{amount}}';
        btn.textContent = label + ' — ' + ecFormatMoney(unitPriceCents * qty, moneyFormat);
      };
      var sync = function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        input.value = v;
        if (display) display.textContent = v;
        updateSubmitPrice(v);
      };
      wrap.querySelectorAll('[data-ec-qty-decrease]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
          sync();
        });
      });
      wrap.querySelectorAll('[data-ec-qty-increase]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 1) + 1;
          sync();
        });
      });
      sync();
    });

    // ---- Add to cart forms: AJAX with graceful fallback to normal form submit ----
    document.querySelectorAll('[data-ec-cart-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-ec-submit]');
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        if (!idInput || !idInput.value) {
          form.submit();
          return;
        }
        if (btn) { btn.disabled = true; btn.dataset.ecOriginalText = btn.textContent; btn.textContent = 'Adding…'; }

        var ecQty = parseInt((qtyInput && qtyInput.value) || '1', 10);

        // Ask /cart/add.js to hand back the cart-drawer's own section HTML in the SAME
        // response (matches how the theme's own native product-form.js — and the Spicy Cube
        // buy box — call this endpoint). Without this, the drawer still opens and the cart
        // total is still correct, but cart-items-component has no ready-made HTML to morph
        // in, so it falls back to a second, much heavier full-section re-render request.
        var ecSectionIds = (window.__ebCartSectionIds && window.__ebCartSectionIds()) || '';

        // Start the cart-drawer open + cart-update event immediately — before the fetch
        // below even begins — using the shared helper in sections/cart-drawer-section.liquid.
        // This is the same pattern the theme's own native product-form.js uses for the
        // built-in buy button: dispatch first, fetch second, resolve last. That ordering is
        // what makes the drawer appear the instant the button is clicked, with the header
        // cart-icon count and drawer contents updating a moment later in the background —
        // never the other way around.
        var ecDeferred = window.__ebBeginCartAdd ? window.__ebBeginCartAdd(idInput.value, ecQty) : null;
        if (!ecDeferred) {
          // Fallback only if the shared helper isn't available for some reason (e.g.
          // cart_type isn't "drawer" so cart-drawer-section.liquid didn't render).
          var ecEagerDrawer = document.getElementById('cart-drawer');
          if (ecEagerDrawer && typeof ecEagerDrawer.open === 'function') {
            ecEagerDrawer.open();
          }
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: idInput.value, quantity: ecQty }],
            sections: ecSectionIds
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add-to-cart failed');
            return res.json();
          })
          .then(function (ecAddResponse) {
            // Resolve the cart-update event dispatched above with the real cart data. This is
            // the piece that syncs the native cart UI (header cart-icon count, cart-items list
            // inside the drawer, totals) the same way the theme's own product forms and the
            // Spicy Cube buy box do — deliberately happening *after* the drawer is already
            // open, not before.
            if (ecDeferred && window.__ebFinishCartAdd) {
              window.__ebFinishCartAdd(ecDeferred, ecAddResponse && ecAddResponse.sections);
            } else if (window.__ebOpenCartDrawerAfterAdd) {
              window.__ebOpenCartDrawerAfterAdd(idInput.value, ecQty, ecAddResponse && ecAddResponse.sections);
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              if (window.theme && typeof window.theme.openCartDrawer === 'function') {
                window.theme.openCartDrawer();
              } else {
                var drawer = document.querySelector('cart-drawer, .cart-drawer, #cart-drawer');
                if (drawer && typeof drawer.open === 'function') {
                  drawer.open();
                } else {
                  window.location.href = '/cart';
                }
              }
            }
          })
          .catch(function (err) {
            if (ecDeferred) ecDeferred.reject(err);
            form.submit();
          })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.ecOriginalText || btn.textContent; }
          });
      });
    });

    // ---- Gallery: thumbnail click, prev/next arrows, and swipe-to-change (touch) ----
    // Everything here is delegated on `document` rather than bound to the individual
    // buttons/images captured at load time. Shopify's theme editor re-renders a
    // section's markup in place (morph) whenever a setting changes, which replaces
    // these elements — a listener attached directly to the old nodes would go silent
    // after that. Delegation always re-queries the live DOM, so it keeps working
    // after any re-render, on the storefront and inside the editor alike.
    (function () {
      function activateThumb(gallery, thumb, opts) {
        if (!gallery || !thumb) return;
        var mainContainer = gallery.querySelector('.ec-gallery-main');
        var full = thumb.getAttribute('data-ec-full-src');
        if (!mainContainer || !full) return;
        var alt = thumb.getAttribute('data-ec-full-alt');

        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ec-gallery-thumb]'));
        var currentIndex = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        var targetIndex = thumbs.indexOf(thumb);
        var direction = (opts && typeof opts.direction === 'number')
          ? opts.direction
          : (targetIndex < currentIndex ? -1 : 1);

        slideToImage(mainContainer, full, alt, direction);

        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.removeAttribute('aria-current');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      }

      // Slides the main image over to `src`, entering from the right when direction
      // is 1 (next) and from the left when direction is -1 (prev) — the outgoing
      // image slides out the opposite side at the same time. No opacity fade.
      function slideToImage(mainContainer, src, alt, direction) {
        // Guard against overlapping transitions if the user clicks/swipes rapidly —
        // wait for the in-flight slide to finish before starting another.
        var inFlight = mainContainer.querySelectorAll('[data-ec-gallery-main-img]');
        if (inFlight.length > 1) return;
        var oldImg = inFlight[0];
        if (!oldImg || oldImg.getAttribute('src') === src) return;

        var newImg = document.createElement('img');
        newImg.setAttribute('data-ec-gallery-main-img', '');
        newImg.setAttribute('src', src);
        newImg.setAttribute('alt', alt || oldImg.getAttribute('alt') || '');
        newImg.setAttribute('width', oldImg.getAttribute('width') || '1200');
        newImg.setAttribute('height', oldImg.getAttribute('height') || '1200');
        newImg.setAttribute('loading', 'eager');
        newImg.style.transition = 'none';
        newImg.style.transform = 'translateX(' + (direction < 0 ? '-100%' : '100%') + ')';
        mainContainer.insertBefore(newImg, oldImg.nextSibling);

        // Force layout so the initial transform above is committed before we
        // animate away from it in the next frame.
        void newImg.offsetWidth;

        requestAnimationFrame(function () {
          newImg.style.transition = '';
          oldImg.style.transform = 'translateX(' + (direction < 0 ? '100%' : '-100%') + ')';
          newImg.style.transform = 'translateX(0)';
        });

        var cleaned = false;
        var cleanup = function () {
          if (cleaned) return;
          cleaned = true;
          if (oldImg.parentNode) oldImg.parentNode.removeChild(oldImg);
        };
        newImg.addEventListener('transitionend', cleanup, { once: true });
        window.setTimeout(cleanup, 500); // fallback if transitionend doesn't fire
      }

      function stepGallery(gallery, direction) {
        if (!gallery) return;
        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ec-gallery-thumb]'));
        if (thumbs.length < 2) return;
        var activeIndex = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        if (activeIndex === -1) activeIndex = 0;
        var nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
        activateThumb(gallery, thumbs[nextIndex], { direction: direction });
      }

      document.addEventListener('click', function (e) {
        var el = e.target.closest && e.target.closest('[data-ec-gallery-thumb], [data-ec-gallery-prev], [data-ec-gallery-next]');
        if (!el) return;
        var gallery = el.closest('[data-ec-gallery]');
        if (!gallery) return;
        if (el.hasAttribute('data-ec-gallery-thumb')) {
          activateThumb(gallery, el);
        } else if (el.hasAttribute('data-ec-gallery-prev')) {
          stepGallery(gallery, -1);
        } else if (el.hasAttribute('data-ec-gallery-next')) {
          stepGallery(gallery, 1);
        }
      });

      // Swipe left/right on the main image to move between photos (touch devices).
      var touchStartX = null;
      var touchGallery = null;
      document.addEventListener('touchstart', function (e) {
        var main = e.target.closest && e.target.closest('.ec-gallery-main');
        if (!main) { touchGallery = null; return; }
        touchGallery = main.closest('[data-ec-gallery]');
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      document.addEventListener('touchend', function (e) {
        if (!touchGallery || touchStartX === null) return;
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        var gallery = touchGallery;
        touchGallery = null;
        touchStartX = null;
        if (Math.abs(deltaX) < 40) return;
        stepGallery(gallery, deltaX < 0 ? 1 : -1);
      }, { passive: true });

      // ---- Variant swatches (e.g. color) — update price/cart id/label in place, no page reload ----
      document.addEventListener('click', function (e) {
        var swatch = e.target.closest && e.target.closest('[data-ec-variant-swatch]');
        if (!swatch) return;
        e.preventDefault();
        if (swatch.classList.contains('is-active')) return;

        var picker = swatch.closest('[data-ec-variant-picker]');
        var heroGrid = swatch.closest('.ec-hero-grid');
        if (!picker || !heroGrid) return;

        var variantId = swatch.getAttribute('data-variant-id');
        var variantTitle = swatch.getAttribute('data-variant-title') || '';
        var variantUrl = swatch.getAttribute('data-variant-url');
        var priceCents = parseInt(swatch.getAttribute('data-variant-price'), 10);
        var compareAtCents = parseInt(swatch.getAttribute('data-variant-compare-at-price'), 10);
        var available = swatch.getAttribute('data-variant-available') === 'true';
        var imageSrc = swatch.getAttribute('data-variant-image');
        var imageAlt = swatch.getAttribute('data-variant-image-alt');

        picker.querySelectorAll('[data-ec-variant-swatch]').forEach(function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');

        var titleEl = picker.querySelector('[data-ec-variant-title]');
        if (titleEl) titleEl.textContent = variantTitle;

        var form = heroGrid.querySelector('[data-ec-cart-form]');
        var btn = form && form.querySelector('[data-ec-submit]');
        var moneyFormat = (btn && btn.getAttribute('data-money-format')) || '${{amount}}';

        if (form) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = variantId;
        }

        var priceRow = heroGrid.querySelector('[data-ec-price-row]');
        if (priceRow && !isNaN(priceCents)) {
          var nowEl = priceRow.querySelector('[data-ec-price-now]');
          var wasEl = priceRow.querySelector('[data-ec-price-was]');
          var badgeEl = priceRow.querySelector('[data-ec-price-badge]');
          if (nowEl) nowEl.textContent = ecFormatMoney(priceCents, moneyFormat);
          var hasDiscount = !isNaN(compareAtCents) && compareAtCents > priceCents;
          if (wasEl) {
            wasEl.hidden = !hasDiscount;
            if (hasDiscount) wasEl.textContent = ecFormatMoney(compareAtCents, moneyFormat);
          }
          if (badgeEl) {
            badgeEl.hidden = !hasDiscount;
            if (hasDiscount) {
              var savePct = Math.round(((compareAtCents - priceCents) * 100) / compareAtCents);
              badgeEl.textContent = 'Sale ' + savePct + '%';
            }
          }
        }

        if (btn) {
          if (!isNaN(priceCents)) btn.setAttribute('data-unit-price-cents', String(priceCents));
          if (available) {
            btn.disabled = false;
            var qtyInput = form && form.querySelector('[data-ec-qty-input]');
            var qty = parseInt((qtyInput && qtyInput.value) || '1', 10);
            if (isNaN(qty) || qty < 1) qty = 1;
            var label = btn.getAttribute('data-cta-label') || '';
            if (!isNaN(priceCents)) btn.textContent = label + ' — ' + ecFormatMoney(priceCents * qty, moneyFormat);
          } else {
            btn.disabled = true;
            var soldOutLabel = btn.getAttribute('data-sold-out-label');
            if (soldOutLabel) btn.textContent = soldOutLabel;
          }
        }

        if (imageSrc) {
          var gallery = heroGrid.querySelector('[data-ec-gallery]');
          if (gallery) {
            var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ec-gallery-thumb]'));
            var matchingThumb = thumbs.filter(function (t) { return t.getAttribute('data-ec-full-src') === imageSrc; })[0];
            if (matchingThumb) {
              activateThumb(gallery, matchingThumb, { direction: 1 });
            } else {
              var mainContainer = gallery.querySelector('.ec-gallery-main');
              if (mainContainer) slideToImage(mainContainer, imageSrc, imageAlt, 1);
            }
          }
        }

        if (variantUrl && window.history && window.history.replaceState) {
          window.history.replaceState(null, '', variantUrl);
        }
      });
    })();

    // ---- Experience steps: mobile-only accordion (desktop is always fully visible via CSS, no JS needed) ----
    (function () {
      var stepsMq = window.matchMedia('(max-width:760px)');

      function setStepOpenState(step, shouldOpen) {
        step.classList.toggle('is-open', shouldOpen);
      }

      document.querySelectorAll('.ec-steps').forEach(function (group) {
        var steps = group.querySelectorAll('[data-ec-step]');
        steps.forEach(function (step, i) {
          var toggle = step.querySelector('[data-ec-step-toggle]');
          if (toggle) {
            toggle.addEventListener('click', function () {
              if (!stepsMq.matches) return; // desktop: no-op, text is always shown via CSS
              setStepOpenState(step, !step.classList.contains('is-open'));
            });
          }
          // Initial mobile state: first step open, rest closed
          setStepOpenState(step, stepsMq.matches && i === 0);
        });
      });

      var onStepsMqChange = function () {
        document.querySelectorAll('.ec-steps').forEach(function (group) {
          group.querySelectorAll('[data-ec-step]').forEach(function (step, i) {
            setStepOpenState(step, stepsMq.matches && i === 0);
          });
        });
      };
      if (stepsMq.addEventListener) stepsMq.addEventListener('change', onStepsMqChange);
      else stepsMq.addListener(onStepsMqChange); // Safari fallback
    })();

    // ---- Reviews: load more / read less (toggle) ----
    document.querySelectorAll('[data-ec-load-more]').forEach(function (btn) {
      var moreLabel = btn.getAttribute('data-ec-more-label') || btn.textContent;
      var lessLabel = btn.getAttribute('data-ec-less-label') || 'Read Less Reviews';
      var expanded = false;
      btn.addEventListener('click', function () {
        var targetSel = btn.getAttribute('data-ec-load-more-target');
        var target = targetSel ? document.querySelector(targetSel) : btn.closest('[data-ec-review-grid]');
        if (!target) return;
        var extraCards = target.querySelectorAll('.ec-review-extra');
        expanded = !expanded;
        extraCards.forEach(function (card) {
          card.classList.toggle('ec-review-hidden', !expanded);
        });
        btn.textContent = expanded ? lessLabel : moreLabel;
        if (!expanded) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  });
})();
